









import mixins from 'vue-typed-mixins';
import LocationBasedMixin from '@/Shared/LocationBasedMixin';
import { PaymentResult } from '@/Payment/PaymentResult';
import buildEntityComponentMixin from '@/Shared/CommonEntityMixins/EntityComponentMixin';
import BootRelease from './BootRelease.vue';
import PaymentCompletion from '@/Payment/PaymentCompletion.vue';

const component = mixins(LocationBasedMixin, buildEntityComponentMixin<PaymentResult>()).extend({
    name: 'CitationPaymentCompletion',
    components: {
        BootRelease,
        PaymentCompletion,
    },
    props: {
        responseId: {
            type: String,
            required: false
        },
        response: {
            type: Object as () => PaymentResult,
            required: false,
        }
    },
    data() {
        return {
            i18nPrefix: 'payment.citationPayment.completion',
            loadBeforeMount: !this.response,
            entity: this.response
        };
    },
    computed: {
        entityUrls(): string {
            return `${this.location}/Payments/ProcessorResponse/${this.responseId}`;
        }
    },
});

export default component;
